export default __webpack_public_path__ + "static/media/medkinza.904f53bb.jpeg";